import { combineEpics } from 'redux-observable';
import * as Rx from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Sentry from '@sentry/browser';

import * as moleculeObjectEpics from '@f/components/shared/compound-editor/utils/molecule-object/molecule-object.epics';
import * as moleculeUtilEpics from '@f/components/shared/compound-editor/utils/molecule-util/molecule-util.epics';

import * as notificationEpics from './notification/notification.epics';
import * as startingMaterialEpics from './starting-material/starting-material.epics';

function catchable(epicMap) {
  return Object.values(epicMap).map(epic => {
    return (...args) =>
      epic(...args).pipe(
        catchError(error => {
          Sentry.captureException(error);
          return Rx.EMPTY;
        })
      );
  });
}

export default combineEpics(
  ...catchable(notificationEpics),
  ...catchable(moleculeObjectEpics),
  ...catchable(moleculeUtilEpics),
  ...catchable(startingMaterialEpics)
);
